import { useState, useEffect } from 'react';
import { getPrimaryBrandIdRpc } from '../../__generated__/chirp/com/hubspot/business/units/rpc/BusinessUnitsService';
import { chirpClient } from '../utils/chirpClient';
let cachedPromise;
function fetchPrimaryBrandId() {
  if (cachedPromise === undefined) {
    cachedPromise = chirpClient.call(getPrimaryBrandIdRpc, {}).then(response => response.primaryBrandId).catch(e => {
      cachedPromise = undefined;
      throw e;
    });
  }
  return cachedPromise;
}
export function usePrimaryBrandId() {
  const [primaryBrandId, setPrimaryBrandId] = useState(0);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let cancelled = false;
    fetchPrimaryBrandId().then(id => {
      if (!cancelled) setPrimaryBrandId(id);
    }).catch(e => {
      console.error('[usePrimaryBrandId] Failed to fetch primary brand ID', e);
    }).finally(() => {
      if (!cancelled) setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, []);
  return {
    primaryBrandId,
    loading
  };
}